export default class callNowNotificationManager {
    constructor() {
        this.phoneInput = $('#instant_call_request_phoneNumber');
        if (this.phoneInput && document.querySelector('#request-call-notification') && document.querySelector('#request-call-created')) {
            this.callNowIntlTelInput = window.intlTelInputGlobals.getInstance(this.phoneInput.get(0));
            this.eventDelegation();
        }
    }

    eventDelegation() {
        this.callNowIntlTelInput.setNumber('+' + this.phoneInput.data('value'));
        let haveFailedPayment = $('#havePaymentFailed');
        let showCallMeNow = $('#showCallMeNow');
        if (showCallMeNow.length > 0 && showCallMeNow.val() == '1') {
            if (haveFailedPayment.length > 0 && haveFailedPayment.val() == '1') {
                document.querySelector('#request-call-notification').openCustomNotification();
                this.validateIntTel();
            } else {
                this.countDown(300); //Duration in seconds
            }
        }

        $("body").on('click', '#instant_call_request_submit', (event) => {
            $('#instant_call_request_submit').button('loading');
            event.preventDefault();
            event.stopImmediatePropagation();
            $('[data-container="internalError"]').hide();
            let form = $('form[name="instant_call_request"]');
            let url = form.attr('action');
            let phone = this.callNowIntlTelInput.getNumber().replace('+', '');
            let bookingId = $('#instant_call_request_bookingId').val();
            let token = $('#instant_call_request_token').val();
            if (this.validateIntTel() !== false) {
                $.ajax({
                    type: 'POST',
                    url: url,
                    data: {
                        'phone': phone,
                        'bookingId': bookingId,
                        'token': token
                    }, success: function (data) {
                        let responseJSON = JSON.parse(data);
                        if (responseJSON.code === 200) {
                            document.querySelector('#request-call-notification').closeCustomNotification();
                            document.querySelector('#request-call-created').openCustomNotification();
                        } else {
                            $('[data-container="internalError"]').show();
                            $('#instant_call_request_submit').attr('disabled', false);
                        }
                    }
                });
            }
        });

        $('body').on('keyup change countrychange', '#instant_call_request_phoneNumber', (event) => {
            this.validateIntTel();
        });
    }

    validateIntTel() {
        this.repositionLabel();
        if (this.callNowIntlTelInput.isValidNumber()) {
            $('[data-container="invalidPhone"]').hide();
            $('#instant_call_request_submit').attr('disabled', false);
            return true;
        }
        $('[data-container="invalidPhone"]').show();
        $('#instant_call_request_submit').attr('disabled', true);
        return false;
    }

    repositionLabel() {
        const label = document.querySelector('label[for=' + this.callNowIntlTelInput.telInput.id + ']');
        if (label) {
            label.style.left = this.callNowIntlTelInput.telInput.style.paddingLeft;
        }
    }

    countDown(duration) {
        let timer = duration;

        let interVal = setInterval(() => {
            if (--timer < 0) {
                timer = duration;
                document.querySelector('#request-call-notification').openCustomNotification();
                this.repositionLabel();
                clearInterval(interVal)
            }
        }, 1000);
    }
}
